module.exports = "<div class=\"chart-container col-md-12 float-left\">\n  <kegomate-line-chart></kegomate-line-chart>\n</div>"